import { ASSETS, IMG, PROCESS_STEPS } from "@/data/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

const CRAFT_IMAGES = [
  { src: ASSETS.bridgeSaw, alt: "Technoline bridge saw cutting slabs at the ShilpStones plant", caption: "Precision Cutting" },
  { src: ASSETS.cncMachine, alt: "CNC engraving machine carving black granite at the ShilpStones plant", caption: "CNC Precision" },
  { src: ASSETS.artisanBlue, alt: "ShilpStones artisan chiseling a stone block at the plant", caption: "Hand Carving" },
  { src: ASSETS.artisanGreen, alt: "ShilpStones craftsman hand-finishing stone at the plant", caption: "Hand Finishing" },
  { src: ASSETS.artisanPainting, alt: "Artisan hand-painting a Shrinathji stone panel at the plant", caption: "Hand Painting" },
];

export default function Process() {
  return (
    <section data-testid="process-section" className="bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <SectionHeading
          eyebrow="Our Process"
          title="From First Sketch to Final Stone"
          script="Every Step a Statement"
          description="A quiet, exacting journey — five stages, one uncompromising standard."
        />
        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
          {PROCESS_STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.12}>
              <div data-testid={`process-step-${i}`} className="group relative border-t-2 border-gold/30 pt-8 transition-colors duration-500 hover:border-gold">
                <span className="gold-grad-text font-serif text-5xl font-semibold sm:text-6xl">{s.num}</span>
                <h3 className="mt-4 font-display text-sm font-semibold uppercase tracking-[0.3em] text-stone-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-600">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-20 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {CRAFT_IMAGES.map((c, i) => (
            <Reveal key={c.caption} delay={i * 0.15}>
              <div data-testid={`craft-image-${i}`} className="group spotlight-frame relative overflow-hidden rounded-2xl">
                <img
                  src={c.src}
                  alt={c.alt}
                  loading="lazy"
                  className="aspect-[16/9] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 to-transparent" />
                <p className="absolute bottom-5 left-6 font-serif text-2xl italic text-stone-100">
                  {c.caption}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
